export const CLIENT = {
  siren: 'Siren',
};

export const NOTHING = '';



// WEBPACK FOOTER //
// ./src/i18n/fr/client/client.js